<template>
  <tw-ui-button class="tw-header-nav-trigger" aria-label="toggle-navigation-button">
    <Icon name="bi:list" class="icon" />
  </tw-ui-button>
</template>

<style lang="scss" scoped>
.tw-header-nav-trigger {
  padding: 0;

  &,
  &:hover,
  &:focus {
    border: none;
    outline: none;
  }
}

.icon {
  width: 2rem;
  height: 2rem;
}
</style>
